import {addressAsString} from "../../components/AddressForm";
import {Link} from "react-router-dom";

export default function Client(properties){

    const keys = Object.keys(properties);
    const {id,name,  address, nip, description,persons, buildings, rajcompany } = properties;

    return {
        id:id,
        name:name,
        address : addressAsString(address),
        persons : persons.length,
        nip:nip,
        description: description,
        buildings:buildings,
        buildings_link:<Link to={`/buildings?clientId=${id}`} >{buildings}</Link>,
        rajcompany: rajcompany.full_name ? rajcompany.full_name : "",
        search: function(query){

            if(query === undefined || query.length <= 0)
                return true;

            const pattern = new RegExp(query,"gi");

            for(let key of keys){
                if(pattern.test(this[key]))
                    return true;
            }

            return false;
        }
    }
}